import { useRouter, type NextRouter } from 'next/router';

export type AppRouter = NextRouter;

/**
 * App-wide router hook. Currently backed by Next.js, but callers should
 * depend on this hook (and the `AppRouter` type) rather than `next/router`
 * directly so we can swap the implementation during the Next.js migration.
 */
export const useAppRouter = (): AppRouter => useRouter();
